<template>
    <div class="agency-list">
        <div class="page-header">
			<h1>Agency List</h1>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
				<el-breadcrumb-item>Agency</el-breadcrumb-item>
				<el-breadcrumb-item>List</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
        <work-in-progress />
    </div>
</template>

<script>
export default {
    name: 'AgencyList'
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables';

</style>



// WEBPACK FOOTER //
// src/views/agency/AgencyList.vue